class RouteNames {
}
RouteNames.Alarms = "alarms";
RouteNames.AlarmsForSystem = "system-alarms";
RouteNames.AlarmType = "alarm-type";
RouteNames.AlarmTypes = "alarm-types";
RouteNames.EventType = "event-type";
RouteNames.EventTypes = "event-types";
RouteNames.Applications = "applications";
RouteNames.Application = "application";
RouteNames.ArtificialAddresses = "artificial-addresses";
RouteNames.BlockTypes = "block-types";
RouteNames.CatchAll = "catch-all";
RouteNames.ChangePassword = "change-password";
RouteNames.Communications = "communications";
RouteNames.Companies = "companies";
RouteNames.Company = "company";
RouteNames.ComponentTypes = "component-types";
RouteNames.Discharge = "discharge";
RouteNames.Errors = "errors";
RouteNames.ForgottenPassword = "forgotten-password";
RouteNames.Home = "home";
RouteNames.Login = "login";
RouteNames.SsoCallback = "sso-callback";
RouteNames.TwoFactorAuth = "two-factor-auth";
RouteNames.Logout = "logout";
RouteNames.MaintenanceComment = "comment";
RouteNames.MaintenanceComments = "comments";
RouteNames.Manufacturer = "manufacturer";
RouteNames.Manufacturers = "manufacturers";
RouteNames.MeasurementTypes = "measurement-types";
RouteNames.Model = "model";
RouteNames.MyProfile = "my-profile";
RouteNames.Notifications = "notifications";
RouteNames.Events = "events";
RouteNames.Issue = "issue";
RouteNames.Issues = "issues";
RouteNames.NotificationHistory = "notification-history";
RouteNames.Regions = "regions";
RouteNames.Reports = "reports";
RouteNames.Sites = "sites";
RouteNames.Site = "site";
RouteNames.Snapshot = "snapshot";
RouteNames.RealTime = "real-time";
RouteNames.SnapshotForSystem = "system-snapshot";
RouteNames.SnapshotForString = "string-snapshot";
RouteNames.System = "system";
RouteNames.Systems = "systems";
RouteNames.SystemRegistration = "register-system";
RouteNames.Terms = "terms-and-conditions";
RouteNames.TermsOnPrem = "terms-and-conditions-onprem";
RouteNames.Trend = "trend";
RouteNames.TrendForSystem = "system-trend";
RouteNames.TrendForString = "string-trend";
RouteNames.TrendForBlock = "block-trend";
RouteNames.TrendForMeasurement = "measurement-trend";
RouteNames.User = "user";
RouteNames.Users = "users";
RouteNames.SMTPImporterSettings = "SMTPImporterSettings";
RouteNames.SMTPImporterLogs = "SMTPImporterLogs";
RouteNames.ReportPermissions = "ReportPermissions";
RouteNames.DataGaps = "DataGaps";
RouteNames.ComponentLimits = "ComponentLimits";
RouteNames.About = "about";
export default RouteNames;
